import { type FleetFuelIntegration, NewFuelCardRequester } from '@cobliteam/api-lib';
import { Environment } from '@cobliteam/react-environments';
import { useQuery } from '@tanstack/react-query';

// Hierarchical on purpose, like `CARD_PROVIDERS_QUERY_KEY`: an invalidation of the `fuelCard`
// domain has to see this key too.
export const FLEET_FUEL_INTEGRATIONS_QUERY_KEY = ['fuelCard', 'fleetIntegrations'] as const;

/**
 * The read behind `E1`/`T1` (FND-07). The dialog that owns E1 only mounts this hook once it is
 * open, never on page load — so there is no `enabled` to gate: mounting is the gate.
 *
 * `retry: false` is part of the fail-closed contract on `telas/00-E1.jpg`: "Tentar novamente volta
 * ao estado E1 e refaz a chamada" is a user action, not a silent background retry that would delay
 * reaching E2 by several seconds behind React Query's default backoff.
 *
 * `refetchOnReconnect: false` for the same reason `refetchOnWindowFocus` is off: a background
 * refetch triggered by the network coming back must not flip `isFetching`/`isError` under a
 * customer who is already past `T1`, filling out `T2` (see the `!showRequestModal` guards in
 * `IntegrationStatusModal`).
 */
const useFleetFuelIntegrations = () => {
  return useQuery<FleetFuelIntegration[]>({
    queryKey: [...FLEET_FUEL_INTEGRATIONS_QUERY_KEY],
    queryFn: () => new NewFuelCardRequester({ host: Environment.getInstance().getEnvironment().apiHost }).getFleetIntegrations(),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

export default useFleetFuelIntegrations;
